import { useEffect, useState } from 'react';

// Store
import vehiclesMap from '../../store/vehiclesMap';
import user from '../../store/user';

function useVehicles() {
    const [vehicles, setVehicles] = useState([]);
    const [, useVehiclesMap] = vehiclesMap();
    const [userStore] = user();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (userStore?.token) {
            fetchData();
        }
    }, [userStore?.token]);

    const fetchData = async () => {
        setLoading(true);

        try {
            const res = await useVehiclesMap.getVehicleMap(userStore.token);
            setVehicles(res?.vehicles || []);
        } catch (e) {
            if (e?.status === 401) return;
        } finally {
            setLoading(false);
        }
    };

    return {
        vehicles,
        loading,
    };
}

export default useVehicles;
